import { clientFor, type PageQuery, type PageResult } from '@yc/api-client'

const api = clientFor('/wms/api')

export interface StockRow {
  id: number
  tenant_id: number
  warehouse_id: number
  location_id: number
  sku_id: number
  batch_no: string
  production_date: string | null
  expiry_date: string | null
  qty: number
  locked_qty: number
  created_at: string
  updated_at: string
  sku_code: string
  sku_name: string
  unit: string
  location_code: string
  warehouse_name: string
  /** 可用量 = qty - locked_qty，波次锁走的部分不算 */
  available: number
}

export interface StockQuery extends PageQuery {
  /** 商品编码/名称/条码或批次号 */
  keyword?: string
  warehouse?: number
  location?: number
}

export interface MoveRow {
  id: number
  tenant_id: number
  move_type: string
  warehouse_id: number
  sku_id: number
  batch_no: string
  qty_delta: number
  from_location_id: number
  to_location_id: number
  ref_type: string
  ref_no: string
  operator: string
  moved_at: string
  created_at: string
  sku_code: string
  sku_name: string
  from_location_code: string
  to_location_code: string
  warehouse_name: string
}

export interface MoveQuery extends PageQuery {
  keyword?: string
  warehouse?: number
  /** 流水类型（MOVE_LABELS 的键），空为全部 */
  move_type?: string
  /** moved_at 起止，YYYY-MM-DD */
  from?: string
  to?: string
}

export interface TransferInput {
  stock_id: number
  to_location_id: number
  qty: number
}

/** 与后端 services/wms/internal/stock/stock.go 的 MoveNames 保持一致，改一边必须改另一边 */
export const MOVE_LABELS: Record<string, string> = {
  in: '入库',
  putaway: '上架',
  out: '出库',
  adjust: '盘点调整',
  transfer: '移库',
  pick_lock: '拣货锁定',
  pick_release: '拣货释放',
  expired: '过期报废',
}

export const listStocks = (q: StockQuery): Promise<PageResult<StockRow>> =>
  api.get<PageResult<StockRow>>('/stocks', { ...q })

export const transferStock = (input: TransferInput): Promise<unknown> =>
  api.post<unknown>('/stocks/transfer', input)

export const listStockMoves = (q: MoveQuery): Promise<PageResult<MoveRow>> =>
  api.get<PageResult<MoveRow>>('/stock-moves', { ...q })
